<!-- <ef-loading [loading]="IsLoading"></ef-loading> -->

<div style="display: flex">
    <p-dialog header="Do you want to withhold fee earned after the fee amount is reached?"
        [(visible)]="showFeeAmtDialog" [maximizable]="false" [closable]="false" [closeOnEscape]="false">
        <h3>
            YES (recommended) will stop fee invoicing at the fee amount and
            track the fee earned in excess. NO will continue invoicing fee
            beyond the amount.
        </h3>
        <ng-template #footer >
            <button type="button" pButton icon="pi pi-check" (click)="feeAmtDialogAction('YES')" label="YES"
                class="p-button-text p-button-success"></button>
            <button type="button" pButton (click)="feeAmtDialogAction('NO')" icon="pi pi-times" label="NO"
                class="p-button-text p-button-danger"></button>
        </ng-template>
    </p-dialog>
</div>

<p-dialog header="Defined Fee" [modal]="true" [(visible)]="showDefinedFeeDialog" [style]="{ width: '25rem' }">
    <span class="p-text-secondary block mb-4">Add defined fee for selected contract(s)/charge numbers(s).</span>
    <form [formGroup]="addFormGroup" #addForm="ngForm" id="addForm">
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <p-select
                class="w-full"
                inputId="ctsel"
                [options]="contractTypesSelectItem"
                [filter]="true"
                appendTo="body"
                formControlName="ContractType">
            </p-select>
            <label for="ctsel">Contract Type</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <p-multiSelect
                class="w-full"
                inputId="cmsel"
                maxSelectedLabels="1"
                appendTo="body"
                [options]="contractsSelectItem"
                [filter]="true"
                formControlName="Contract">
            </p-multiSelect>
            <label for="cmsel">Contract</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <p-multiSelect
                class="w-full"
                inputId="cnmsel"
                maxSelectedLabels="1"
                appendTo="body"
                [options]="chargeNumbersSelectItem"
                [filter]="true"
                formControlName="ChargeNumber">
            </p-multiSelect>
            <label for="cnmsel">{{ chargeNumberDDPlaceholder }}</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <input class="w-full" inputId="fee%" pInputText type="text" formControlName="FeePercent" />
            <label for="fee%">Fee %</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <input class="w-full" inputId="fa" pInputText type="text" formControlName="FeeAmount" />
            <label for="fa">Fee Amount</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56 mb-3" variant="on">
            <input class="w-full" inputId="fh" pInputText type="text" formControlName="FeeHours" />
            <label for="fh">Fee Hours</label>
        </p-floatlabel>
        <p-floatlabel class="w-full md:w-56" variant="on">
            <p-datepicker
                styleClass="w-full"
                [monthNavigator]="true"
                [minDate]=""
                [maxDate]="this.today"
                [yearNavigator]="true"
                yearRange="2000:2030"
                appendTo="body"
                [showIcon]="true"
                inputId="ed"
                formControlName="ed">
            </p-datepicker>
            <label for="ed">Effective Date</label>
        </p-floatlabel>
    </form>
    <ng-template #footer>
        <button pButton pRipple severity="success" text label="Submit" (click)="addClicked()"></button>
    </ng-template>
</p-dialog>

<div class="card">
    <!-- (activeIndexChange)="onActiveIndexChange($event)" -->
    <!-- <p-accordion>
        <p-accordionTab header="Define Fee for Contract/Charge Number" [selected]="false">
            <form [formGroup]="addFormGroup" #addForm="ngForm" id="addForm">
                <p-toolbar>
                    <span class="p-float-label">
                        <p-dropdown [options]="contractTypesSelectItem" [filter]="true" appendTo="body"
                            [autoDisplayFirst]="false" placeholder="Contract Type" formControlName="ContractType">
                        </p-dropdown>
                        <label for="float-dd">Contract Type</label>
                    </span>
                    <span class="p-float-label">
                        <p-multiSelect maxSelectedLabels="1" appendTo="body" [options]="contractsSelectItem"
                            placeholder="Contract" [filter]="true" formControlName="Contract">
                        </p-multiSelect>
                        <label for="float-dd">Contract</label>
                    </span>
                    <span class="p-float-label">
                        <p-multiSelect maxSelectedLabels="1" appendTo="body" [options]="chargeNumbersSelectItem"
                            [filter]="true" [placeholder]="chargeNumberDDPlaceholder" formControlName="ChargeNumber">
                        </p-multiSelect>

                        <label for="float-dd">{{
                            chargeNumberDDPlaceholder
                            }}</label>
                    </span>
                    <input pInputText type="text" placeholder="Fee %" formControlName="FeePercent" />
                    <input pInputText type="text" placeholder="Fee Amount" formControlName="FeeAmount" />
                    <input pInputText type="text" placeholder="Fee Hours" formControlName="FeeHours" />
                    <span class="p-float-label">
                        <p-datepicker [monthNavigator]="true" [minDate]="" [maxDate]="this.today" [yearNavigator]="true"
                            yearRange="2000:2030" appendTo="body" [showIcon]="false" id="ed" formControlName="ed">
                        </p-datepicker>
                        <label for="float-dd">Effective Date</label>
                    </span>
                    <button pButton pRipple class="p-button-secondary" icon="pi pi-plus-circle" label="Add"
                        (click)="addClicked()"></button>
                </p-toolbar>
            </form>
        </p-accordionTab>
    </p-accordion> -->

    <p-accordion [multiple]="true" (activeIndexChange)="handleOnOpen($event)">
        <p-accordionTab header="Contract/Charge Numbers with Fee Defined" [(selected)]="activeState[0]"
            contentStyleClass="fee-level-first-panel">
            <div class="fee-level-table-container" [ngStyle]="{ 'height': feeLevelContainerHeight }">
                <p-toolbar>
                    <button type="button" pButton pRipple icon="pi pi-download" (click)="FeeLevelTable.exportCSV()"
                        class="p-button-secondary mr-2" pTooltip="Download" tooltipPosition="bottom"></button>
                    <p-multiSelect defaultLabel="Select Contract(s)" maxSelectedLabels="1" appendTo="body"
                        [options]="loadContractsSelectItem" [filter]="true" maxSelectedLabels="1"
                        selectedItemsLabel="{0} items selected" (onChange)="onChangeContracts($event)">
                    </p-multiSelect>
                    <div class="flex items-center mt-1">
                        <p-checkbox binary="true" inputId="iia" (onChange)="onCheckboxChange($event)"
                        [(ngModel)]="activeOnly"></p-checkbox>
                        <label for="iia" class="ml-2"> Include Inactive </label>
                    </div>
                    <!-- <button pButton pRipple class="p-button-text" label="Clear Filters"
                        (click)="clearTableFilters()"></button> -->
                    <button pButton pRipple class="p-button-text" label="Show/Hide Withholding"
                        (click)="showHideWithholding()"></button>

                    <p-message severity="info" text="Select a row to view the contract's history."></p-message>
                    <button pButton pRipple severity="primary" (click)="showDefinedFeeDialog = true;" label="Add Defined Fee"></button>
                    <!-- <ef-column-search [elements]="elements"></ef-column-search> -->
                </p-toolbar>

                <p-table stripedRows #FeeLevelTable [loading]="IsLoading" [scrollable]="true"
                    [style]="{ 'min-width': '1200px' }" scrollHeight="flex" [value]="feeLevels"
                    [columns]="cols" editMode="row" (onEditInit)="onEditInit($event)"
                    (onRowEditSave)="onRowEditSave($event)" dataKey="FeeSetupID"
                    [(selection)]="this.selectedContract" selectionMode="single"
                    (onRowSelect)="onContractSelected($event)" [virtualScroll]="true">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="19" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr >
                            <th class="edit-cell" pFrozenColumn [frozen]="IsColumnFrozen"></th>
                            <th class="status-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                                <i class="pi pi-exclamation-circle"></i>
                            </th>
                            <th pSortableColumn="ContractDesc" pFrozenColumn [frozen]="IsColumnFrozen">
                                Contract
                                <p-sortIcon field="ContractDesc" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="ContractListID" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter"
                                            [virtualScroll]="true" [itemSize]="30" maxSelectedLabels="1"
                                            appendTo="body" [options]="cFilterSelectItem"
                                            [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                                            [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)">
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th pSortableColumn="ChargeNumber" pFrozenColumn [frozen]="IsColumnFrozen">
                                Charge Number
                                <p-sortIcon field="ChargeNumber" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter type="text" matchMode="contains" field="ChargeNumber" display="menu" class="ml-auto" />
                            </th>
                            <th pSortableColumn="ContractType">
                                Contract Type
                                <p-sortIcon field="ContractType" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="ContractType" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter"
                                            maxSelectedLabels="1" appendTo="body" [options]="ctFilterSelectItem"
                                            [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)">
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th pSortableColumn="EffectiveDate">
                                Effective Date
                                <p-sortIcon field="EffectiveDate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="FeePercentage">
                                Fee %
                                <p-sortIcon field="FeePercentage" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="FeeAmount">
                                Fee Amt.
                                <p-sortIcon field="FeeAmount" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="EstHours">
                                Est. Hours
                                <p-sortIcon field="EstHours" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="FeeonGA">
                                Fee on GA
                                <p-sortIcon field="FeeonGA" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="FeeBilledCumulative">
                                Fee Invoiced
                                <p-sortIcon field="FeeBilledCumulative" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="FeeRetainCumulative">
                                Fee Withheld
                                <p-sortIcon field="FeeRetainCumulative" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th class="separator-cell"></th>
                            <th pSortableColumn="FeeRetainFull_FeeAmount" *ngIf="this.withholding == true">
                                Start 100% Withholding
                                <p-sortIcon field="FeeRetainFull_FeeAmount" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th class="separator-cell"></th>
                            <th pSortableColumn="FeeRetainPercentStartDate" *ngIf="this.withholding == true">
                                Withholding Start
                                <p-sortIcon field="FeeRetainPercentStartDate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="FeeRetainPercent" *ngIf="this.withholding == true">
                                Withholding Fee %
                                <p-sortIcon field="FeeRetainPercent" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="FeeRetainStop_FeeAmount" *ngIf="this.withholding == true">
                                Stop at Fee Invoiced
                                <p-sortIcon field="FeeRetainStop_FeeAmount" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="FeeRetainStop_RetainedAmount" *ngIf="this.withholding == true">
                                Stop at Fee Withheld
                                <p-sortIcon field="FeeRetainStop_RetainedAmount" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="ModifiedDate">
                                Modified Date
                                <p-sortIcon field="ModifiedDate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="ModifiedBy">
                                Modified By
                                <p-sortIcon field="ModifiedBy" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th class="delete-cell"></th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-feelvl let-edit="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="feelvl" data-id="row-{{ feelvl.FeeSetupID }}" [pSelectableRow]="feelvl">
                            <td class="edit-cell" style="text-align: center; align-items: center" pFrozenColumn [frozen]="IsColumnFrozen">
                                <button *ngIf="
                                        !edit &&
                                        (!editing?.FeeSetupID ||
                                            !editing?.FeeSetupID ===
                                                feelvl?.FeeSetupID)
                                    " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                    (click)="onRowEditInit(feelvl)" class="p-button-rounded p-button-text"
                                    style="height: 1.4rem; width: 1.4rem" title="Edit"></button>
                                <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow
                                    icon="pi pi-check" (click)="onRowEditSave(feelvl)"
                                    class="p-button-rounded p-button-text p-button-success" style="
                                        margin-right: 0.5em;
                                        height: 1.4rem;
                                        width: 1.4rem;
                                    "></button>
                                <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" (click)="onRowEditCancel(feelvl)"
                                    class="p-button-rounded p-button-text p-button-danger"
                                    style="height: 1.4rem; width: 1.4rem"></button>
                            </td>
                            <td class="status-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                                <div style="height: 2em; align-self: center">
                                    <a (click)="onStatusClick(feelvl)">
                                        <div>
                                            <ef-status-icon [status]="
                                                    feelvl?.Status?.StatusCode
                                                " [message]="feelvl?.Status?.Message"></ef-status-icon>
                                        </div>
                                    </a>
                                </div>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                <label [title]="feelvl.ContractDesc">
                                    {{ feelvl.ContractDesc }}
                                </label>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                {{ feelvl.ChargeNumber }}
                            </td>
                            <td>
                                {{ feelvl.ContractType }}
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <p-datepicker [(ngModel)]="feelvl.EffectiveDate" appendTo="body"
                                            [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"
                                            [minDate]="this.minDate" [maxDate]="this.today">
                                        </p-datepicker>
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="feelvl.EffectiveDate">
                                            {{
                                            moment(feelvl.EffectiveDate).format(
                                            'MM/DD/YYYY'
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="feelvl.FeePercentage"
                                            [disabled]="this.CPFF_LOE" />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="+feelvl.FeePercentage != 0">
                                            {{
                                            percentFormatter(
                                            +feelvl.FeePercentage
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="feelvl.FeeAmount"
                                            (focus)="onFeeAmtFocus($event)" (blur)="onFeeAmtUnfocus($event)" />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="+feelvl.FeeAmount != 0">
                                            {{
                                            currencyFormatter.format(
                                            +feelvl.FeeAmount
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="feelvl.EstHours"
                                            [disabled]="!this.CPFF_LOE" />
                                    </ng-template>
                                    <ng-template #output>
                                        {{ feelvl.EstHours }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <div *ngIf="this.feeOnGASelectItem as items">
                                            <p-dropdown [style]="{ width: '100%' }" [options]="items" [filter]="false" appendTo="body" [(ngModel)]="feelvl.FeeonGA"></p-dropdown>
                                        </div>
                                    </ng-template>
                                    <ng-template #output>
                                        {{ this.findFeeOnGA(feelvl) }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <div *ngIf="+feelvl.FeeBilledCumulative != 0">
                                    {{
                                    currencyFormatter.format(
                                    +feelvl.FeeBilledCumulative
                                    )
                                    }}
                                </div>
                            </td>
                            <td>
                                <div *ngIf="+feelvl.FeeRetainCumulative != 0">
                                    {{
                                    currencyFormatter.format(
                                    +feelvl.FeeRetainCumulative
                                    )
                                    }}
                                </div>
                            </td>
                            <td class="separator-cell"></td>
                            <td *ngIf="this.withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input [class.blinking]="feeAmtFocused" pInputText type="text" [(ngModel)]="
                                                feelvl.FeeRetainFull_FeeAmount
                                            " />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="
                                                +feelvl.FeeRetainFull_FeeAmount != 0
                                            ">
                                            {{
                                            currencyFormatter.format(
                                            +feelvl.FeeRetainFull_FeeAmount
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="separator-cell"></td>
                            <td *ngIf="this.withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <p-datepicker [(ngModel)]="
                                                feelvl.FeeRetainPercentStartDate
                                            " appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                            yearRange="2000:2030">
                                        </p-datepicker>
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="feelvl.FeeRetainPercentStartDate">
                                            {{
                                            moment(
                                            feelvl.FeeRetainPercentStartDate
                                            ).format('MM/DD/YYYY')
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="feelvl.FeeRetainPercent" />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="+feelvl.FeeRetainPercent != 0">
                                            {{
                                            percentFormatter(
                                            +feelvl.FeeRetainPercent
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="
                                                feelvl.FeeRetainStop_FeeAmount
                                            " />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="
                                                +feelvl.FeeRetainStop_FeeAmount != 0
                                            ">
                                            {{
                                            currencyFormatter.format(
                                            +feelvl.FeeRetainStop_FeeAmount
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="
                                                feelvl.FeeRetainStop_RetainedAmount
                                            " />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="
                                                +feelvl.FeeRetainStop_RetainedAmount !=
                                                0
                                            ">
                                            {{
                                            currencyFormatter.format(
                                            +feelvl.FeeRetainStop_RetainedAmount
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <div>
                                    {{
                                    feelvl.ModifiedDate
                                    ? moment(feelvl.ModifiedDate).format(
                                    'L'
                                    )
                                    : ''
                                    }}
                                </div>
                            </td>
                            <td>
                                <div>{{ feelvl.ModifiedBy }}</div>
                            </td>
                            <td class="delete-cell">
                                <button class="p-button-danger p-button-rounded p-button-text" pButton type="button"
                                    icon="pi pi-trash" (click)="DeleteFee(feelvl)"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-accordionTab>

        <p-accordionTab [header]="this.feeHistoryHeader" [(selected)]="activeState[1]">
            <p-toolbar>
                <form [formGroup]="histFormGroup" #addForm="ngForm" id="histForm">
                    <p-datepicker [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"
                        selectionMode="range" placeholder="Choose a date range..." [showIcon]="false"
                        formControlName="dateRange" id="historyDates" (onSelect)="onDateRangeSelected()"
                        appendTo="body">
                    </p-datepicker>
                </form>

                <!-- <button pButton pRipple class="p-button-text" label="Clear Filters"
                    (click)="clearHistoryTableFilters()"></button> -->
                <button pButton pRipple class="p-button-text" label="Show/Hide Withholding"
                    (click)="showHideHistoryWithholding()"></button>
            </p-toolbar>
            <div [ngStyle]="{ 'height': feeHistContainerHeight }">
                <p-table stripedRows #FeeHistoryTable [value]="feeHistory" scrollHeight="flex" [scrollable]="true"
                    [style]="{ 'min-width': '1200px' }" editMode="row" (onEditInit)="onHistEditInit($event)" (onRowEditSave)="onHistRowEditSave($event)"
                    dataKey="id" [virtualRowHeight]="10" [resizableColumns]="true" columnResizeMode="expand" [virtualScroll]="true">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="19" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr >
                            <th class=" edit-cell" pFrozenColumn [frozen]="IsColumnFrozen"></th>
                            <th class=" status-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                                <i class="pi pi-exclamation-circle"></i>
                            </th>
                            <th pSortableColumn="StartDate" pFrozenColumn [frozen]="IsColumnFrozen">
                                <div class="tabulator-col-content">
                                    Period Start
                                    <p-sortIcon field="StartDate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="EndDate" pFrozenColumn [frozen]="IsColumnFrozen">
                                <div class="tabulator-col-content">
                                    Period End
                                    <p-sortIcon field="EndDate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="PeriodStatus">
                                <div class="tabulator-col-content">
                                    Period Status
                                    <p-sortIcon field="PeriodStatus" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="ChargeNumber" *ngIf="this.AreHistCNs == true">
                                <div class="tabulator-col-content">
                                    Charge Number
                                    <p-sortIcon field="ChargeNumber" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <p-columnFilter field="CNListID" matchMode="in" display="menu"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                        class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect defaultLabel="Filter"
                                                maxSelectedLabels="1" appendTo="body"
                                                [options]="hist_cnFilterSelectItem" [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="ContractType">
                                <div class="tabulator-col-content">
                                    Contract Type
                                    <p-sortIcon field="ContractType" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                    <p-columnFilter field="ContractType" matchMode="in" display="menu"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                        class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect defaultLabel="Filter"
                                                maxSelectedLabels="1" appendTo="body"
                                                [options]="hist_ctFilterSelectItem" [filter]="true" styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="FeePercentage">
                                <div class="tabulator-col-content">
                                    Fee %
                                    <p-sortIcon field="FeePercentage" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>

                            <th pSortableColumn="FeeAmount">
                                <div class="tabulator-col-content">
                                    Fee Amount
                                    <p-sortIcon field="FeeAmount" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>

                            <th pSortableColumn="EstHours">
                                <div class="tabulator-col-content">
                                    Est. Hours
                                    <p-sortIcon field="EstHours" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="FeeonGA">
                                <div class="tabulator-col-content">
                                    Fee on GA
                                    <p-sortIcon field="FeeonGA" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>

                            <th class="separator-cell"></th>

                            <th pSortableColumn="FeeRetainFull_FeeAmount" *ngIf="this.hist_withholding == true">
                                <div class="tabulator-col-content">
                                    Start 100% Withholding
                                    <p-sortIcon field="FeeRetainFull_FeeAmount" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>

                            <th class="separator-cell"></th>

                            <th pSortableColumn="FeeRetainPercent" *ngIf="this.hist_withholding == true">
                                <div class="tabulator-col-content">
                                    Withholding Fee %
                                    <p-sortIcon field="FeeRetainPercent" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>

                            <th pSortableColumn="FeeRetainPercentStartDate" *ngIf="this.hist_withholding == true">
                                <div class="tabulator-col-content">
                                    Withholding Start
                                    <p-sortIcon field="FeeRetainPercentStartDate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>

                            <th pSortableColumn="FeeRetainStop_FeeAmount" *ngIf="this.hist_withholding == true">
                                <div class="tabulator-col-content">
                                    Stop at Fee Invoiced
                                    <p-sortIcon field="FeeRetainStop_FeeAmount" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="FeeRetainStop_RetainedAmount"
                                *ngIf="this.hist_withholding == true">
                                <div class="tabulator-col-content">
                                    Stop at Fee Withheld
                                    <p-sortIcon field="FeeRetainStop_RetainedAmount" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="ModifiedDate">
                                <div class="tabulator-col-content">
                                    Modified Date
                                    <p-sortIcon field="ModifiedDate" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                            <th pSortableColumn="ModifiedBy">
                                <div class="tabulator-col-content">
                                    Modified By
                                    <p-sortIcon field="ModifiedBy" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-feehist let-edit="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="feehist" data-id="row-{{ feehist.id }}">
                            <td class="edit-cell" style="text-align: center; align-items: center" pFrozenColumn [frozen]="IsColumnFrozen">
                                <button *ngIf="
                                        !edit &&
                                        (!histEditing?.id ||
                                            !histEditing?.id === feehist?.id)
                                    " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                    (click)="onHistRowEditInit(feehist)" class="p-button-rounded p-button-text"
                                    style="height: 1.4rem; width: 1.4rem" title="Edit"></button>
                                <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow
                                    icon="pi pi-check" (click)="onHistRowEditSave(feehist)"
                                    class="p-button-rounded p-button-text p-button-success" style="
                                        margin-right: 0.5em;
                                        height: 1.4rem;
                                        width: 1.4rem;
                                    "></button>
                                <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" (click)="onHistRowEditCancel(feehist)"
                                    class="p-button-rounded p-button-text p-button-danger"
                                    style="height: 1.4rem; width: 1.4rem"></button>
                            </td>
                            <td class="status-cell" pFrozenColumn [frozen]="IsColumnFrozen">
                                <div style="height: 2em; align-self: center">
                                    <a (click)="onStatusClick(feehist)">
                                        <div>
                                            <ef-status-icon [status]="
                                                    feehist?.Status?.StatusCode
                                                " [message]="
                                                    feehist?.Status?.Message
                                                "></ef-status-icon>
                                        </div>
                                    </a>
                                </div>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                <div *ngIf="feehist.StartDate">
                                    {{
                                    moment(feehist.StartDate).format(
                                    'MM/DD/YYYY'
                                    )
                                    }}
                                </div>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                <div *ngIf="feehist.EndDate">
                                    {{
                                    moment(feehist.EndDate).format(
                                    'MM/DD/YYYY'
                                    )
                                    }}
                                </div>
                            </td>
                            <td>
                                {{ feehist.PeriodStatus }}
                            </td>
                            <td *ngIf="this.AreHistCNs == true">
                                {{ feehist.ChargeNumber }}
                            </td>
                            <td>
                                {{ feehist.ContractType }}
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="feehist.FeePercentage"
                                            [disabled]="this.hist_CPFF_LOE" />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="+feehist.FeePercentage != 0">
                                            {{
                                            percentFormatter(
                                            +feehist.FeePercentage
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="feehist.FeeAmount"
                                            [disabled]="!this.hist_CPFF_LOE" />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="+feehist.FeeAmount != 0">
                                            {{
                                            currencyFormatter.format(
                                            +feehist.FeeAmount
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="feehist.EstHours"
                                            [disabled]="!this.hist_CPFF_LOE" />
                                    </ng-template>
                                    <ng-template #output>
                                        {{ feehist.EstHours }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template #input>
                                        <div *ngIf="
                                                this.feeOnGASelectItem as items
                                            ">
                                            <p-dropdown [options]="items" [virtualScroll]="true" [filter]="false"
                                                appendTo="body" [autoDisplayFirst]="false"
                                                [(ngModel)]="feehist.FeeonGA">
                                            </p-dropdown>
                                        </div>
                                    </ng-template>
                                    <ng-template #output>
                                        {{ this.findFeeOnGA(feehist) }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <th class="separator-cell"></th>
                            <td *ngIf="this.hist_withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="
                                                feehist.FeeRetainFull_FeeAmount
                                            " />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="
                                                +feehist.FeeRetainFull_FeeAmount !=
                                                0
                                            ">
                                            {{
                                            currencyFormatter.format(
                                            +feehist.FeeRetainFull_FeeAmount
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <th class="separator-cell"></th>
                            <td *ngIf="this.hist_withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="
                                                feehist.FeeRetainPercent
                                            " />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="
                                                +feehist.FeeRetainPercent != 0
                                            ">
                                            {{
                                            percentFormatter(
                                            +feehist.FeeRetainPercent
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.hist_withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <p-datepicker [(ngModel)]="
                                                feehist.FeeRetainPercentStartDate
                                            " appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                            yearRange="2000:2030">
                                        </p-datepicker>
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="
                                                feehist.FeeRetainPercentStartDate
                                            ">
                                            {{
                                            moment(
                                            feehist.FeeRetainPercentStartDate
                                            ).format('MM/DD/YYYY')
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.hist_withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="
                                                feehist.FeeRetainStop_FeeAmount
                                            " />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="
                                                +feehist.FeeRetainStop_FeeAmount !=
                                                0
                                            ">
                                            {{
                                            currencyFormatter.format(
                                            +feehist.FeeRetainStop_FeeAmount
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.hist_withholding == true">
                                <p-cellEditor>
                                    <ng-template #input>
                                        <input pInputText type="text" [(ngModel)]="
                                                feehist.FeeRetainStop_RetainedAmount
                                            " />
                                    </ng-template>
                                    <ng-template #output>
                                        <div *ngIf="
                                                +feehist.FeeRetainStop_RetainedAmount !=
                                                0
                                            ">
                                            {{
                                            currencyFormatter.format(
                                            +feehist.FeeRetainStop_RetainedAmount
                                            )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <div>
                                    {{
                                    feehist.ModifiedDate
                                    ? moment(
                                    feehist.ModifiedDate
                                    ).format('L')
                                    : ''
                                    }}
                                </div>
                            </td>
                            <td>
                                <div>{{ feehist.ModifiedBy }}</div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
